<template>
  <div class="admin-wrap">
    <el-row :gutter="10" style="width: 100%">
      <el-col :span="5">
        <el-button v-if="!isEdit" size="mini" type="warning" @click="handleAdd">
          新增
        </el-button>
        <el-button
          v-if="!isEdit"
          size="mini"
          type="primary"
          @click="handleEdit"
        >
          编辑
        </el-button>
        <el-button
          v-if="!isEdit"
          size="mini"
          type="danger"
          @click="handleDelete"
        >
          删除
        </el-button>
        <el-button v-if="isEdit" size="mini" @click="handleCancel"
          >取消</el-button
        >
        <el-button v-if="isEdit" size="mini" type="success" @click="handleSave">
          保存
        </el-button>
        <div class="input-wrap">
          <el-form ref="configForm" label-width="100px" :model="configForm">
            <el-form-item label="账号名称">
              <el-input v-model="configForm.user_name"></el-input>
            </el-form-item>
            <el-form-item label="项目名称">
              <el-input v-model="configForm.title"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
      <el-col :span="19">
        <div class="table-wrap">
          <el-table
            ref="config_table"
            @row-click="handleClick"
            highlight-current-row
            size="small"
            :data="tableData"
            border
          >
            <el-table-column
              align="center"
              prop="user_name"
              label="账号名称"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="title"
              label="项目名称"
            ></el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import * as service from "@/api/api";
export default {
  data() {
    return {
      configForm: {},
      tableData: [],
      operateType: "add",
      isEdit: false,
    };
  },
  mounted() {
    if (sessionStorage.getItem("userName") === "linxianliang") {
      this.getConfigData();
    } else {
      this.$router.push({
        name: "login",
        path: "/",
      });
    }
  },
  methods: {
    getConfigData() {
      this.tableData = [];
      service.getConfigData().then((res) => {
        let resData = res.data;
        if (resData.data && resData.data.length) {
          this.tableData = resData.data;
          this.$refs.config_table.setCurrentRow(this.tableData[0]);
          this.handleClick(this.tableData[0]);
        }
      });
    },
    handleClick(row) {
      this.configForm = Object.assign({}, row);
    },
    handleAdd() {
      this.operateType = "add";
      this.isEdit = true;
      this.configForm = {};
    },
    handleEdit() {
      this.operateType = "edit";
      this.isEdit = true;
    },
    handleCancel() {
      this.isEdit = false;
      this.getConfigData();
    },
    handleSave() {
      let operateApi =
        this.operateType === "add" ? "addConfig" : "updateConfig";
      service[operateApi](this.configForm).then((res) => {
        if (res.data.code === 200) {
          this.$message({
            showClose: true,
            message: "保存成功!",
            type: "success",
          });
          this.isEdit = false;
          this.getConfigData();
        } else {
          this.$message({
            showClose: true,
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    handleDelete() {
      this.$confirm("确认删除？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消",
      }).then(() => {
        service.deleteConfig(this.configForm.id).then((res) => {
          if (res.data.code === 200) {
            this.$message({
              showClose: true,
              message: "删除成功!",
              type: "success",
            });
            this.getConfigData();
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: "error",
            });
          }
        });
      });
    },
  },
};
</script>

<style scoped>
.admin-wrap {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  display: flex;
  padding: 50px 20px;
}
.input-wrap {
  margin-top: 20px;
}
</style>
